import React, { useCallback } from 'react';
import { connect } from 'react-redux';

// components
import CardTray from './index';

// selectors, misc utils
import { getCompareTrayData } from 'page_modules/business-vac/redux';
import {
  getCardListData,
  getSelectedCompareCards,
  dispatchAddCardToCompare,
  dispatchPreselectedCardsArrived,
  dispatchRemoveCardFromCompare
} from 'src/universal/redux/compareCardsTray';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import { addRemoveButtonData } from 'page_modules/business-vac/redux';
import { addRemoveCtaHandler } from 'page_modules/business-vac/utils';
import { mapUrlWithDtmLinkQuery } from 'service_modules/models/dtm-tagging';
import { hasOneXpRequestFinished } from 'src/universal/redux/oneXp';

const CardTrayHolder = ({
  comparedCards,
  selectedCards,
  compareTrayData,
  addRemoveProps,
  addCardToCompare,
  removeCardFromCompare,
  onCompareTrayEmptyItemClick,
  oneXpDecided
}) => {
  if (!oneXpDecided) {
    return null;
  }

  const buildCardListForTray = useCallback(
    () => {
      const list = [null, null, null];
      const cardList = Array.isArray(comparedCards) ? comparedCards : [];
      for (let i = 0; i < cardList.length; i++) {
        list[i] = cardList[i];
      }

      return list;
    },
    [comparedCards]
  );

  const onAddRemoveButtonClicked = card => {
    addRemoveCtaHandler(
      card.cardHeadline,
      { ...addRemoveProps },
      addCardToCompare,
      removeCardFromCompare,
      false,
      null,
      card.shortName
    );
  };

  const onCompareTrayRemoveClick = cardObj => {
    onAddRemoveButtonClicked(cardObj);
  };

  const onCompareTrayMainActionClick = useCallback(
    () => {
      const { url, dtmTag } = compareTrayData;
      const nonNullCards = comparedCards.filter(eachCard => !!eachCard);
      const comparedCardsProductName = nonNullCards
        .map(eachCard => eachCard.dtmProductName)
        .join('_');

      const formattedDtm = {
        ...dtmTag,
        eventAsset: replaceStringWithVars({
          varsObject: {
            numOfCards: nonNullCards.length,
            productNames: comparedCardsProductName
          },
          string: dtmTag.eventAsset
        })
      };
      const urlVal = mapUrlWithDtmLinkQuery(url, formattedDtm);
      sendDTMClickEvent(formattedDtm);
      window.location.href = urlVal;
    },
    [comparedCards]
  );

  if (!Array.isArray(selectedCards) || selectedCards.length <= 0) {
    return null;
  }

  const trayProps = {
    cardList: buildCardListForTray(),
    actionButtonLabel: compareTrayData?.title || 'Compare',
    onActionButtonClick: onCompareTrayMainActionClick,
    onRemoveIconClick: onCompareTrayRemoveClick,
    onEmptyCardClick: onCompareTrayEmptyItemClick
  };

  return (
    <div className="section-background card-tray-wrap">
      <div className="card-tray-holder">
        <CardTray {...trayProps} />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    comparedCards: getCardListData(state),
    selectedCards: getSelectedCompareCards(state),
    compareTrayData: getCompareTrayData(state),
    addRemoveProps: addRemoveButtonData(state),
    oneXpDecided: hasOneXpRequestFinished(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addCardToCompare: shortName => dispatchAddCardToCompare(dispatch, { shortName }),
    setCardsInCompareTray: () => dispatchPreselectedCardsArrived(dispatch),
    removeCardFromCompare: shortName =>
      dispatchRemoveCardFromCompare(dispatch, { shortName })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(CardTrayHolder));
